import { Controller } from "stimulus"
import { disableSubmitButtons } from "../form_submission"

export default class extends Controller {
  connect() {
    this.pending = new Map()
  }

  disconnect() {
    this.restore()
  }

  submit(event) {
    if (event.defaultPrevented) return
    const form = event.target
    if (this.pending.has(form)) {
      event.preventDefault()
      return
    }
    // Wait until confirmation, fetch and Active Storage handlers have decided
    // whether the browser will submit. Preserve the native submitter's value.
    const timer = setTimeout(() => {
      this.pending.delete(form)
      if (!event.defaultPrevented) this.pending.set(form, disableSubmitButtons(form))
    }, 13)
    this.pending.set(form, () => clearTimeout(timer))
  }

  uploading(event) {
    this.release(event.target)
    this.pending.set(event.target, disableSubmitButtons(event.target))
  }

  uploaded(event) {
    this.release(event.target)
  }

  fileChanged(event) {
    const input = event.target
    if (!input.matches('input[type="file"][data-direct-upload-url]')) return
    Array.from(input.form.elements).filter(element => element.type === "hidden" && element.name === input.name).forEach(element => element.remove())
  }

  release(form) {
    const restore = this.pending.get(form)
    if (restore) restore()
    this.pending.delete(form)
  }

  restore() {
    this.pending.forEach(restore => restore())
    this.pending.clear()
  }
}
